var _templateObject, _templateObject2, _templateObject3, _templateObject4, _templateObject5, _templateObject6, _templateObject7, _templateObject8, _templateObject9, _templateObject10, _templateObject11, _templateObject12, _templateObject13, _templateObject14, _templateObject15, _templateObject16, _templateObject17, _templateObject18, _templateObject19, _templateObject20, _templateObject21, _templateObject22, _templateObject23, _templateObject24, _templateObject25, _templateObject26, _templateObject27, _templateObject28, _templateObject29, _templateObject30;
function _taggedTemplateLiteral(e, t) { return t || (t = e.slice(0)), Object.freeze(Object.defineProperties(e, { raw: { value: Object.freeze(t) } })); }
/* eslint-disable */

export class RestApplicationClient {
  constructor(httpClient) {
    this.httpClient = httpClient;
  }

  /**
   * HTTP GET /application.wadl
   * Java method: org.glassfish.jersey.server.wadl.internal.WadlResource.getWadl
   */
  getWadl() {
    return this.httpClient.request({
      method: "GET",
      url: uriEncoding(_templateObject || (_templateObject = _taggedTemplateLiteral(["application.wadl"])))
    });
  }

  /**
   * HTTP GET /application.wadl/{path}
   * Java method: org.glassfish.jersey.server.wadl.internal.WadlResource.getExternalGrammar
   */
  getExternalGrammar(path) {
    return this.httpClient.request({
      method: "GET",
      url: uriEncoding(_templateObject2 || (_templateObject2 = _taggedTemplateLiteral(["application.wadl/", ""])), path)
    });
  }

  /**
   * HTTP POST /kyc/complete-declaration
   * Java method: no.eika.felles.kyc.declaration.web.kyc.KnowYourCustomerResource.completeDeclaration
   */
  completeDeclaration() {
    return this.httpClient.request({
      method: "POST",
      url: uriEncoding(_templateObject3 || (_templateObject3 = _taggedTemplateLiteral(["kyc/complete-declaration"])))
    });
  }

  /**
   * HTTP POST /kyc/confirmCaseSummary/{caseId}
   * Java method: no.eika.felles.kyc.declaration.web.kyc.KnowYourCustomerResource.confirmCaseSummary
   */
  confirmCaseSummary(caseId) {
    return this.httpClient.request({
      method: "POST",
      url: uriEncoding(_templateObject4 || (_templateObject4 = _taggedTemplateLiteral(["kyc/confirmCaseSummary/", ""])), caseId)
    });
  }

  /**
   * HTTP POST /kyc/confirmCorporateInformation
   * Java method: no.eika.felles.kyc.declaration.web.kyc.KnowYourCustomerResource.confirmCorporateInformation
   */
  confirmCorporateInformation(arg0) {
    return this.httpClient.request({
      method: "POST",
      url: uriEncoding(_templateObject5 || (_templateObject5 = _taggedTemplateLiteral(["kyc/confirmCorporateInformation"]))),
      data: arg0
    });
  }

  /**
   * HTTP POST /kyc/confirmCountries
   * Java method: no.eika.felles.kyc.declaration.web.kyc.KnowYourCustomerResource.confirmCountries
   */
  confirmCountries(arg0) {
    return this.httpClient.request({
      method: "POST",
      url: uriEncoding(_templateObject6 || (_templateObject6 = _taggedTemplateLiteral(["kyc/confirmCountries"]))),
      data: arg0
    });
  }

  /**
   * HTTP GET /kyc/countries
   * Java method: no.eika.felles.kyc.declaration.web.kyc.KnowYourCustomerResource.countries
   */
  countries() {
    return this.httpClient.request({
      method: "GET",
      url: uriEncoding(_templateObject7 || (_templateObject7 = _taggedTemplateLiteral(["kyc/countries"])))
    });
  }

  /**
   * HTTP GET /kyc/customer/type
   * Java method: no.eika.felles.kyc.declaration.web.kyc.CustomerResource.kycCustomerType
   */
  kycCustomerType() {
    return this.httpClient.request({
      method: "GET",
      url: uriEncoding(_templateObject8 || (_templateObject8 = _taggedTemplateLiteral(["kyc/customer/type"])))
    });
  }

  /**
   * HTTP GET /kyc/keepAlive
   * Java method: no.eika.felles.kyc.declaration.web.kyc.KnowYourCustomerResource.keepAlive
   */
  keepAlive() {
    return this.httpClient.request({
      method: "GET",
      url: uriEncoding(_templateObject9 || (_templateObject9 = _taggedTemplateLiteral(["kyc/keepAlive"])))
    });
  }

  /**
   * HTTP POST /kyc/log
   * Java method: no.eika.felles.kyc.declaration.web.kyc.KnowYourCustomerResource.log
   */
  log() {
    return this.httpClient.request({
      method: "POST",
      url: uriEncoding(_templateObject10 || (_templateObject10 = _taggedTemplateLiteral(["kyc/log"])))
    });
  }

  /**
   * HTTP GET /kyc/pepRoleCountries
   * Java method: no.eika.felles.kyc.declaration.web.kyc.KnowYourCustomerResource.pepRoleCountries
   */
  pepRoleCountries() {
    return this.httpClient.request({
      method: "GET",
      url: uriEncoding(_templateObject11 || (_templateObject11 = _taggedTemplateLiteral(["kyc/pepRoleCountries"])))
    });
  }

  /**
   * HTTP GET /kyc/pepRoleTypes
   * Java method: no.eika.felles.kyc.declaration.web.kyc.KnowYourCustomerResource.getPepRoleTypes
   */
  getPepRoleTypes() {
    return this.httpClient.request({
      method: "GET",
      url: uriEncoding(_templateObject12 || (_templateObject12 = _taggedTemplateLiteral(["kyc/pepRoleTypes"])))
    });
  }

  /**
   * HTTP GET /kyc/postal-codes
   * Java method: no.eika.felles.kyc.declaration.web.kyc.KnowYourCustomerResource.listNorwegianPostalCodes
   */
  listNorwegianPostalCodes() {
    return this.httpClient.request({
      method: "GET",
      url: uriEncoding(_templateObject13 || (_templateObject13 = _taggedTemplateLiteral(["kyc/postal-codes"])))
    });
  }

  /**
   * HTTP GET /kyc/postal-codes/verify
   * Java method: no.eika.felles.kyc.declaration.web.kyc.KnowYourCustomerResource.checkPostalCode
   */
  checkPostalCode(queryParams) {
    return this.httpClient.request({
      method: "GET",
      url: uriEncoding(_templateObject14 || (_templateObject14 = _taggedTemplateLiteral(["kyc/postal-codes/verify"]))),
      queryParams: queryParams
    });
  }

  /**
   * HTTP GET /kyc/rcaRoleTypes
   * Java method: no.eika.felles.kyc.declaration.web.kyc.KnowYourCustomerResource.getRcaRoleTypes
   */
  getRcaRoleTypes() {
    return this.httpClient.request({
      method: "GET",
      url: uriEncoding(_templateObject15 || (_templateObject15 = _taggedTemplateLiteral(["kyc/rcaRoleTypes"])))
    });
  }

  /**
   * HTTP POST /kyc/submitCheckboxSourceOfIncomeSection
   * Java method: no.eika.felles.kyc.declaration.web.kyc.KnowYourCustomerResource.submitCheckboxSourceOfIncomeSection
   */
  submitCheckboxSourceOfIncomeSection(arg0) {
    return this.httpClient.request({
      method: "POST",
      url: uriEncoding(_templateObject16 || (_templateObject16 = _taggedTemplateLiteral(["kyc/submitCheckboxSourceOfIncomeSection"]))),
      data: arg0
    });
  }

  /**
   * HTTP POST /kyc/submitCorporateInstitutionTypeSection
   * Java method: no.eika.felles.kyc.declaration.web.kyc.KnowYourCustomerResource.submitCorporateInstitutionTypeSection
   */
  submitCorporateInstitutionTypeSection(arg0) {
    return this.httpClient.request({
      method: "POST",
      url: uriEncoding(_templateObject17 || (_templateObject17 = _taggedTemplateLiteral(["kyc/submitCorporateInstitutionTypeSection"]))),
      data: arg0
    });
  }

  /**
   * HTTP POST /kyc/submitDynamicSection
   * Java method: no.eika.felles.kyc.declaration.web.kyc.KnowYourCustomerResource.submitDynamicSection
   */
  submitDynamicSection(arg0) {
    return this.httpClient.request({
      method: "POST",
      url: uriEncoding(_templateObject18 || (_templateObject18 = _taggedTemplateLiteral(["kyc/submitDynamicSection"]))),
      data: arg0
    });
  }

  /**
   * HTTP POST /kyc/submitPepRca
   * Java method: no.eika.felles.kyc.declaration.web.kyc.KnowYourCustomerResource.addPepAndRca
   */
  addPepAndRca(arg0) {
    return this.httpClient.request({
      method: "POST",
      url: uriEncoding(_templateObject19 || (_templateObject19 = _taggedTemplateLiteral(["kyc/submitPepRca"]))),
      data: arg0
    });
  }

  /**
   * HTTP POST /kyc/submitSourceOfIncomeSection
   * Java method: no.eika.felles.kyc.declaration.web.kyc.KnowYourCustomerResource.submitSourceOfIncomeSection
   */
  submitSourceOfIncomeSection(arg0) {
    return this.httpClient.request({
      method: "POST",
      url: uriEncoding(_templateObject20 || (_templateObject20 = _taggedTemplateLiteral(["kyc/submitSourceOfIncomeSection"]))),
      data: arg0
    });
  }

  /**
   * HTTP POST /kyc/submitTaxRelationSection
   * Java method: no.eika.felles.kyc.declaration.web.kyc.KnowYourCustomerResource.submitTaxRelationSection
   */
  submitTaxRelationSection(arg0) {
    return this.httpClient.request({
      method: "POST",
      url: uriEncoding(_templateObject21 || (_templateObject21 = _taggedTemplateLiteral(["kyc/submitTaxRelationSection"]))),
      data: arg0
    });
  }

  /**
   * HTTP GET /kyc/taxRelationCountries
   * Java method: no.eika.felles.kyc.declaration.web.kyc.KnowYourCustomerResource.getTaxRelationCountries
   */
  getTaxRelationCountries() {
    return this.httpClient.request({
      method: "GET",
      url: uriEncoding(_templateObject22 || (_templateObject22 = _taggedTemplateLiteral(["kyc/taxRelationCountries"])))
    });
  }

  /**
   * HTTP POST /kyc/token-for-process
   * Java method: no.eika.felles.kyc.declaration.web.kyc.KnowYourCustomerResource.tokenForProcess
   */
  tokenForProcess(arg0) {
    return this.httpClient.request({
      method: "POST",
      url: uriEncoding(_templateObject23 || (_templateObject23 = _taggedTemplateLiteral(["kyc/token-for-process"]))),
      data: arg0
    });
  }

  /**
   * HTTP GET /kyc/v1/case-summary/{caseId}
   * Java method: no.eika.felles.kyc.declaration.web.kyc.KnowYourCustomerResource.caseSummary
   */
  caseSummary(caseId) {
    return this.httpClient.request({
      method: "GET",
      url: uriEncoding(_templateObject24 || (_templateObject24 = _taggedTemplateLiteral(["kyc/v1/case-summary/", ""])), caseId)
    });
  }

  /**
   * HTTP GET /kyc/v1/process-summary
   * Java method: no.eika.felles.kyc.declaration.web.kyc.KnowYourCustomerResource.processSummary
   */
  processSummary() {
    return this.httpClient.request({
      method: "GET",
      url: uriEncoding(_templateObject25 || (_templateObject25 = _taggedTemplateLiteral(["kyc/v1/process-summary"])))
    });
  }

  /**
   * HTTP POST /kyc/v2/complete-declaration
   * Java method: no.eika.felles.kyc.declaration.web.kyc.KnowYourCustomerResource.completeDeclarationV2
   */
  completeDeclarationV2() {
    return this.httpClient.request({
      method: "POST",
      url: uriEncoding(_templateObject26 || (_templateObject26 = _taggedTemplateLiteral(["kyc/v2/complete-declaration"])))
    });
  }

  /**
   * HTTP POST /kyc/v3/corporate-actors
   * Java method: no.eika.felles.kyc.declaration.web.kyc.KnowYourCustomerResource.confirmCorporateActors
   */
  confirmCorporateActors(arg0) {
    return this.httpClient.request({
      method: "POST",
      url: uriEncoding(_templateObject27 || (_templateObject27 = _taggedTemplateLiteral(["kyc/v3/corporate-actors"]))),
      data: arg0
    });
  }

  /**
   * HTTP GET /kyc/v7/form
   * Java method: no.eika.felles.kyc.declaration.web.kyc.KnowYourCustomerResource.formV7
   */
  formV7(queryParams) {
    return this.httpClient.request({
      method: "GET",
      url: uriEncoding(_templateObject28 || (_templateObject28 = _taggedTemplateLiteral(["kyc/v7/form"]))),
      queryParams: queryParams
    });
  }

  /**
   * HTTP GET /kyc/v8/form
   * Java method: no.eika.felles.kyc.declaration.web.kyc.KnowYourCustomerResource.formV8
   */
  formV8(queryParams) {
    return this.httpClient.request({
      method: "GET",
      url: uriEncoding(_templateObject29 || (_templateObject29 = _taggedTemplateLiteral(["kyc/v8/form"]))),
      queryParams: queryParams
    });
  }

  /**
   * HTTP GET /kyc/webBankTask
   * Java method: no.eika.felles.kyc.declaration.web.kyc.KnowYourCustomerResource.webBankTask
   */
  webBankTask() {
    return this.httpClient.request({
      method: "GET",
      url: uriEncoding(_templateObject30 || (_templateObject30 = _taggedTemplateLiteral(["kyc/webBankTask"])))
    });
  }
}
export let AnswerType = /*#__PURE__*/function (AnswerType) {
  AnswerType["YES_NO"] = "YES_NO";
  AnswerType["SINGLE"] = "SINGLE";
  AnswerType["LIST"] = "LIST";
  AnswerType["SIMPLE_LIST"] = "SIMPLE_LIST";
  return AnswerType;
}({});
export let CompletionStatus = /*#__PURE__*/function (CompletionStatus) {
  CompletionStatus["OK"] = "OK";
  CompletionStatus["REQUIRES_MANUAL_CONTROL_BY_ADVISOR"] = "REQUIRES_MANUAL_CONTROL_BY_ADVISOR";
  CompletionStatus["FAILED"] = "FAILED";
  CompletionStatus["AWAITING_EXECUTOR"] = "AWAITING_EXECUTOR";
  CompletionStatus["AWAITING_SIGNEE"] = "AWAITING_SIGNEE";
  return CompletionStatus;
}({});
export let ConditionToShowSubQuestions = /*#__PURE__*/function (ConditionToShowSubQuestions) {
  ConditionToShowSubQuestions["UNKNOWN"] = "UNKNOWN";
  ConditionToShowSubQuestions["ON_YES"] = "ON_YES";
  return ConditionToShowSubQuestions;
}({});
export let ConfirmCountryResponseType = /*#__PURE__*/function (ConfirmCountryResponseType) {
  ConfirmCountryResponseType["OK"] = "OK";
  ConfirmCountryResponseType["NOT_VALID"] = "NOT_VALID";
  ConfirmCountryResponseType["NOT_VERIFIED"] = "NOT_VERIFIED";
  ConfirmCountryResponseType["ERROR"] = "ERROR";
  return ConfirmCountryResponseType;
}({});
export let CorporateActorsConfirmationAnswerType = /*#__PURE__*/function (CorporateActorsConfirmationAnswerType) {
  CorporateActorsConfirmationAnswerType["CONFIRMED"] = "CONFIRMED";
  CorporateActorsConfirmationAnswerType["REJECTED_WITH_COMMENT"] = "REJECTED_WITH_COMMENT";
  return CorporateActorsConfirmationAnswerType;
}({});
export let CorporateActorsConfirmationType = /*#__PURE__*/function (CorporateActorsConfirmationType) {
  CorporateActorsConfirmationType["BENEFICIAL_OWNERS"] = "BENEFICIAL_OWNERS";
  CorporateActorsConfirmationType["BENEFICIAL_OWNERS_V2"] = "BENEFICIAL_OWNERS_V2";
  CorporateActorsConfirmationType["CEO_CHAIRMAN_BOARD"] = "CEO_CHAIRMAN_BOARD";
  CorporateActorsConfirmationType["CEO_CHAIRMAN_BOARD_V2"] = "CEO_CHAIRMAN_BOARD_V2";
  CorporateActorsConfirmationType["READ_ONLY"] = "READ_ONLY";
  return CorporateActorsConfirmationType;
}({});
export let CorporateFormType = /*#__PURE__*/function (CorporateFormType) {
  CorporateFormType["AAFY"] = "AAFY";
  CorporateFormType["ADOS"] = "ADOS";
  CorporateFormType["ANNA"] = "ANNA";
  CorporateFormType["ANS"] = "ANS";
  CorporateFormType["AS"] = "AS";
  CorporateFormType["ASA"] = "ASA";
  CorporateFormType["BA"] = "BA";
  CorporateFormType["BBL"] = "BBL";
  CorporateFormType["BEDR"] = "BEDR";
  CorporateFormType["BO"] = "BO";
  CorporateFormType["BRL"] = "BRL";
  CorporateFormType["DA"] = "DA";
  CorporateFormType["ENK"] = "ENK";
  CorporateFormType["EOFG"] = "EOFG";
  CorporateFormType["ESEK"] = "ESEK";
  CorporateFormType["FKF"] = "FKF";
  CorporateFormType["FLI"] = "FLI";
  CorporateFormType["FYLK"] = "FYLK";
  CorporateFormType["GFS"] = "GFS";
  CorporateFormType["IKJP"] = "IKJP";
  CorporateFormType["IKS"] = "IKS";
  CorporateFormType["KBO"] = "KBO";
  CorporateFormType["KF"] = "KF";
  CorporateFormType["KIRK"] = "KIRK";
  CorporateFormType["KOMM"] = "KOMM";
  CorporateFormType["KS"] = "KS";
  CorporateFormType["KTRF"] = "KTRF";
  CorporateFormType["NUF"] = "NUF";
  CorporateFormType["OPMV"] = "OPMV";
  CorporateFormType["ORGL"] = "ORGL";
  CorporateFormType["PERS"] = "PERS";
  CorporateFormType["PK"] = "PK";
  CorporateFormType["PRE"] = "PRE";
  CorporateFormType["SA"] = "SA";
  CorporateFormType["SAM"] = "SAM";
  CorporateFormType["SE"] = "SE";
  CorporateFormType["SF"] = "SF";
  CorporateFormType["SPA"] = "SPA";
  CorporateFormType["STI"] = "STI";
  CorporateFormType["STAT"] = "STAT";
  CorporateFormType["SAR"] = "SAR";
  CorporateFormType["TVAM"] = "TVAM";
  CorporateFormType["UDEF"] = "UDEF";
  CorporateFormType["UTLA"] = "UTLA";
  CorporateFormType["VPFO"] = "VPFO";
  CorporateFormType["UKJENT"] = "UKJENT";
  CorporateFormType["ANNET"] = "ANNET";
  return CorporateFormType;
}({});
export let FellesKycOrchestrationMsWsError = /*#__PURE__*/function (FellesKycOrchestrationMsWsError) {
  FellesKycOrchestrationMsWsError["INTERNAL_ERROR"] = "INTERNAL_ERROR";
  FellesKycOrchestrationMsWsError["UNAUTHORIZED"] = "UNAUTHORIZED";
  FellesKycOrchestrationMsWsError["SSL_CERTIFICATE_ERROR"] = "SSL_CERTIFICATE_ERROR";
  FellesKycOrchestrationMsWsError["CONFIG_FILE_NOT_FOUND"] = "CONFIG_FILE_NOT_FOUND";
  FellesKycOrchestrationMsWsError["ERROR_PARSING_RESOURCE"] = "ERROR_PARSING_RESOURCE";
  FellesKycOrchestrationMsWsError["TASKROOM_CUSTOM_TEXT_CONFIG_NOT_FOUND"] = "TASKROOM_CUSTOM_TEXT_CONFIG_NOT_FOUND";
  FellesKycOrchestrationMsWsError["INVALID_INPUT"] = "INVALID_INPUT";
  FellesKycOrchestrationMsWsError["TOTAL_OWNERSHIP_OF_RR_IS_MORE_THAN_100_PERCENT"] = "TOTAL_OWNERSHIP_OF_RR_IS_MORE_THAN_100_PERCENT";
  FellesKycOrchestrationMsWsError["CORPORATE_INFORMATION_NOT_FOUND_IN_BISNODE"] = "CORPORATE_INFORMATION_NOT_FOUND_IN_BISNODE";
  FellesKycOrchestrationMsWsError["ERROR_MARKING_FOR_RENEWAL"] = "ERROR_MARKING_FOR_RENEWAL";
  FellesKycOrchestrationMsWsError["OUT_OF_ORDER_CASE_CREATION"] = "OUT_OF_ORDER_CASE_CREATION";
  FellesKycOrchestrationMsWsError["NO_CASE_READY_FOR_SIGNEE"] = "NO_CASE_READY_FOR_SIGNEE";
  FellesKycOrchestrationMsWsError["NO_CASE_READY_FOR_EXECUTOR"] = "NO_CASE_READY_FOR_EXECUTOR";
  FellesKycOrchestrationMsWsError["UNKNOWN_CARD_TYPE"] = "UNKNOWN_CARD_TYPE";
  return FellesKycOrchestrationMsWsError;
}({});
export let FinancialInstitutionType = /*#__PURE__*/function (FinancialInstitutionType) {
  FinancialInstitutionType["LE"] = "LE";
  FinancialInstitutionType["SL"] = "SL";
  FinancialInstitutionType["ME"] = "ME";
  FinancialInstitutionType["BR"] = "BR";
  FinancialInstitutionType["SP"] = "SP";
  FinancialInstitutionType["SF"] = "SF";
  FinancialInstitutionType["SD"] = "SD";
  FinancialInstitutionType["SS"] = "SS";
  FinancialInstitutionType["SB"] = "SB";
  return FinancialInstitutionType;
}({});
export let Gender = /*#__PURE__*/function (Gender) {
  Gender["MALE"] = "MALE";
  Gender["FEMALE"] = "FEMALE";
  Gender["UNKNOWN"] = "UNKNOWN";
  return Gender;
}({});
export let InstitutionType = /*#__PURE__*/function (InstitutionType) {
  InstitutionType["financialInstitution"] = "financialInstitution";
  InstitutionType["nonFinancialInstitution"] = "nonFinancialInstitution";
  return InstitutionType;
}({});
export let KycContext = /*#__PURE__*/function (KycContext) {
  KycContext["NETTBANK"] = "NETTBANK";
  KycContext["SIGNING_ROOM"] = "SIGNING_ROOM";
  KycContext["CUSTOMER_ONBOARDING"] = "CUSTOMER_ONBOARDING";
  KycContext["CUSTOMER_ONBOARDING_DISPONENT"] = "CUSTOMER_ONBOARDING_DISPONENT";
  KycContext["CUSTOMER_ONBOARDING_GUARANTOR"] = "CUSTOMER_ONBOARDING_GUARANTOR";
  KycContext["EKB_CLIENT"] = "EKB_CLIENT";
  KycContext["ADVISOR"] = "ADVISOR";
  return KycContext;
}({});
export let KycCustomerType = /*#__PURE__*/function (KycCustomerType) {
  KycCustomerType["DISPONENT"] = "DISPONENT";
  KycCustomerType["GUARANTOR"] = "GUARANTOR";
  KycCustomerType["NORMAL"] = "NORMAL";
  KycCustomerType["NOT_FOUND"] = "NOT_FOUND";
  return KycCustomerType;
}({});
export let KycProcess = /*#__PURE__*/function (KycProcess) {
  KycProcess["BECOME_PRIVATE_CUSTOMER"] = "BECOME_PRIVATE_CUSTOMER";
  KycProcess["BECOME_DISPONENT_CUSTOMER"] = "BECOME_DISPONENT_CUSTOMER";
  KycProcess["BECOME_GUARANTOR_CUSTOMER"] = "BECOME_GUARANTOR_CUSTOMER";
  KycProcess["BECOME_CHILD_CUSTOMER"] = "BECOME_CHILD_CUSTOMER";
  KycProcess["BECOME_CORPORATE_CUSTOMER"] = "BECOME_CORPORATE_CUSTOMER";
  KycProcess["RENEWAL_PRIVATE"] = "RENEWAL_PRIVATE";
  KycProcess["RENEWAL_CHILD"] = "RENEWAL_CHILD";
  KycProcess["RENEWAL_CORPORATE"] = "RENEWAL_CORPORATE";
  KycProcess["CREDIT_CARD"] = "CREDIT_CARD";
  KycProcess["CREDIT_LOAN"] = "CREDIT_LOAN";
  KycProcess["CAR_LOAN"] = "CAR_LOAN";
  return KycProcess;
}({});
export let KycSectionSummaryType = /*#__PURE__*/function (KycSectionSummaryType) {
  KycSectionSummaryType["BM_ACTORS"] = "BM_ACTORS";
  KycSectionSummaryType["BM_FINANCIAL_INSTITUTION"] = "BM_FINANCIAL_INSTITUTION";
  KycSectionSummaryType["BM_TAX"] = "BM_TAX";
  KycSectionSummaryType["BM_INFO"] = "BM_INFO";
  KycSectionSummaryType["COMMON_CHECKBOX_SOURCE_OF_INCOME"] = "COMMON_CHECKBOX_SOURCE_OF_INCOME";
  KycSectionSummaryType["COMMON_SOURCE_OF_INCOME"] = "COMMON_SOURCE_OF_INCOME";
  KycSectionSummaryType["COMMON_DYNAMIC"] = "COMMON_DYNAMIC";
  KycSectionSummaryType["PM_COUNTRY"] = "PM_COUNTRY";
  KycSectionSummaryType["PM_PEP"] = "PM_PEP";
  KycSectionSummaryType["PM_TAX"] = "PM_TAX";
  return KycSectionSummaryType;
}({});
export let KycStatus = /*#__PURE__*/function (KycStatus) {
  KycStatus["OK"] = "OK";
  KycStatus["AML_REQUIRED"] = "AML_REQUIRED";
  KycStatus["BLOCKED"] = "BLOCKED";
  KycStatus["CUSTOMER_NOT_FOUND"] = "CUSTOMER_NOT_FOUND";
  return KycStatus;
}({});
export let ListFieldType = /*#__PURE__*/function (ListFieldType) {
  ListFieldType["UNKNOWN"] = "UNKNOWN";
  ListFieldType["DROP_DOWN"] = "DROP_DOWN";
  ListFieldType["AMOUNT"] = "AMOUNT";
  ListFieldType["INTEGER"] = "INTEGER";
  ListFieldType["STRING"] = "STRING";
  return ListFieldType;
}({});
export let Month = /*#__PURE__*/function (Month) {
  Month["JANUARY"] = "JANUARY";
  Month["FEBRUARY"] = "FEBRUARY";
  Month["MARCH"] = "MARCH";
  Month["APRIL"] = "APRIL";
  Month["MAY"] = "MAY";
  Month["JUNE"] = "JUNE";
  Month["JULY"] = "JULY";
  Month["AUGUST"] = "AUGUST";
  Month["SEPTEMBER"] = "SEPTEMBER";
  Month["OCTOBER"] = "OCTOBER";
  Month["NOVEMBER"] = "NOVEMBER";
  Month["DECEMBER"] = "DECEMBER";
  return Month;
}({});
export let QuestionArea = /*#__PURE__*/function (QuestionArea) {
  QuestionArea["CORPORATE"] = "CORPORATE";
  QuestionArea["PRIVATE"] = "PRIVATE";
  return QuestionArea;
}({});
export let QuestionType = /*#__PURE__*/function (QuestionType) {
  QuestionType["UNKNOWN"] = "UNKNOWN";
  QuestionType["CHOICE_YES_NO"] = "CHOICE_YES_NO";
  QuestionType["DROP_DOWN"] = "DROP_DOWN";
  QuestionType["AMOUNT"] = "AMOUNT";
  QuestionType["INTEGER"] = "INTEGER";
  QuestionType["STRING"] = "STRING";
  QuestionType["TEXT_AREA"] = "TEXT_AREA";
  QuestionType["LIST"] = "LIST";
  QuestionType["CHECKBOX_LIST"] = "CHECKBOX_LIST";
  return QuestionType;
}({});
export let SearchActive = /*#__PURE__*/function (SearchActive) {
  SearchActive["ALL"] = "ALL";
  SearchActive["ACTIVE"] = "ACTIVE";
  SearchActive["NOT_ACTIVE"] = "NOT_ACTIVE";
  return SearchActive;
}({});
export let SearchAttribute = /*#__PURE__*/function (SearchAttribute) {
  SearchAttribute["ALL"] = "ALL";
  SearchAttribute["VERIFIED"] = "VERIFIED";
  SearchAttribute["REJECTED"] = "REJECTED";
  SearchAttribute["EVALUATED"] = "EVALUATED";
  SearchAttribute["NOT_EVALUATED"] = "NOT_EVALUATED";
  return SearchAttribute;
}({});
export let SectionType = /*#__PURE__*/function (SectionType) {
  SectionType["welcome"] = "welcome";
  SectionType["welcomeWithProducts"] = "welcomeWithProducts";
  SectionType["country"] = "country";
  SectionType["corporateTax"] = "corporateTax";
  SectionType["corporateBoardActorsV2"] = "corporateBoardActorsV2";
  SectionType["corporateBoardActorsV3"] = "corporateBoardActorsV3";
  SectionType["corporateBeneficialOwnerActorsV2"] = "corporateBeneficialOwnerActorsV2";
  SectionType["corporateBeneficialOwnerActorsV3"] = "corporateBeneficialOwnerActorsV3";
  SectionType["readonlyActorsSection"] = "readonlyActorsSection";
  SectionType["corporateFinancialInstitution"] = "corporateFinancialInstitution";
  SectionType["tax"] = "tax";
  SectionType["pep"] = "pep";
  SectionType["dynamic"] = "dynamic";
  SectionType["sourceOfIncome"] = "sourceOfIncome";
  SectionType["checkboxSourceOfIncome"] = "checkboxSourceOfIncome";
  SectionType["informationSection"] = "informationSection";
  SectionType["corporateInformationSection"] = "corporateInformationSection";
  SectionType["caseSummary"] = "caseSummary";
  SectionType["processSummary"] = "processSummary";
  return SectionType;
}({});
export let TaxClassificationType = /*#__PURE__*/function (TaxClassificationType) {
  TaxClassificationType["FINANCIAL_INSTITUTION"] = "FINANCIAL_INSTITUTION";
  TaxClassificationType["ACTIVE"] = "ACTIVE";
  TaxClassificationType["PASSIVE"] = "PASSIVE";
  return TaxClassificationType;
}({});
export let TaxRelationType = /*#__PURE__*/function (TaxRelationType) {
  TaxRelationType["WITH_TAX_NUMBER"] = "WITH_TAX_NUMBER";
  TaxRelationType["WITH_OUT_TAX_NUMBER"] = "WITH_OUT_TAX_NUMBER";
  return TaxRelationType;
}({});
export let TextTarget = /*#__PURE__*/function (TextTarget) {
  TextTarget["CUSTOMER"] = "CUSTOMER";
  TextTarget["BANK"] = "BANK";
  TextTarget["GUARDIAN"] = "GUARDIAN";
  return TextTarget;
}({});
export let ValueType = /*#__PURE__*/function (ValueType) {
  ValueType["UNKNOWN"] = "UNKNOWN";
  ValueType["COUNTRY"] = "COUNTRY";
  ValueType["PRODUCTS_PM"] = "PRODUCTS_PM";
  ValueType["PRODUCTS_BM"] = "PRODUCTS_BM";
  return ValueType;
}({});
export let WebBankTaskSeverity = /*#__PURE__*/function (WebBankTaskSeverity) {
  WebBankTaskSeverity["NORMAL"] = "NORMAL";
  WebBankTaskSeverity["PENDING"] = "PENDING";
  WebBankTaskSeverity["OVERDUE"] = "OVERDUE";
  WebBankTaskSeverity["MANDATORY"] = "MANDATORY";
  return WebBankTaskSeverity;
}({});
export let YesNoAnswer = /*#__PURE__*/function (YesNoAnswer) {
  YesNoAnswer["YES"] = "YES";
  YesNoAnswer["NO"] = "NO";
  return YesNoAnswer;
}({});
function uriEncoding(template) {
  let result = "";
  for (let i = 0; i < (arguments.length <= 1 ? 0 : arguments.length - 1); i++) {
    result += template[i];
    result += encodeURIComponent(i + 1 < 1 || arguments.length <= i + 1 ? undefined : arguments[i + 1]);
  }
  result += template[template.length - 1];
  return result;
}